import type { GreetAvatarNotification as GreetAvatarNotificationType } from '@/@types/notification'
import HeartIcon from '@/assets/heart.svg?react'
import ClickableStackAvatarGroup from '@/components/ClickableStackAvatarGroup'
import ScreenNames from '@/components/ScreenNames'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './GreetAvatarNotification.module.css'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'

export interface GreetAvatarNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: GreetAvatarNotificationType
}

export default function GreetAvatarNotification({
	data,
	className,
	...props
}: GreetAvatarNotificationProps) {
	const {
		actionItem: { users, usersCount },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<div className={styles.content}>
				<header className={styles.header}>
					<HeartIcon className={styles.icon} />
					<div className={styles.headerText}>
						<ScreenNames data={users.slice(0, 3)} className={styles.screenNames} />
						<span className={styles.secondaryText}>
							{usersCount > 3 && <span>等{usersCount}人</span>}
							弹了你的头像
						</span>
					</div>
				</header>

				<main>
					<ClickableStackAvatarGroup data={users} className={styles.avatarGroup} />
				</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
